import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import TickGreenIcon from "../../../../Assets/svg/tick-green.svg"
import CartIcon from "../../../../Assets/svg/shopping-cart.svg"
import CartIconFilled from "../../../../Assets/svg/shopping-cart-filled.svg"
import packageCardStyles from "./PackageCard.module.css"

const PackageCard = ({ name, price, offerPrice, isAddedInCart, slug, handleAccordionClose, handleAddressModalOpen, onOpenModal }) => {
  const history = useHistory();
  const city = useSelector((state) => state.cityOnTopNav.citySelect);

  const handleBookClick = (slug) => {
    // (handleAccordionClose)();
    handleAddressModalOpen(slug, "book");
    // setTimeout(() => {
    //   history.push(`/${slug}${city ? "-" + city.toLowerCase() : ""}`)
    // }, 500)
  }

  const handleAddToCartClick = () => {
    if (isAddedInCart)
      return;
    (handleAccordionClose)();
    history.push(`/${slug}${city ? "-" + city.toLowerCase() : ""}`)
    // setTimeout(() => {
    //   history.push(`/${slug}${city ? "-" + city.toLowerCase() : ""}`)
    // }, 500)
  }


  return (
    <>
    <div className={packageCardStyles.packageCard}>
      <div className={packageCardStyles.packageCardTop} onClick={() => onOpenModal()}>
        <span className={packageCardStyles.packageCardName}>
          {name}
        </span>
      </div>

      <div className={packageCardStyles.packageCardUsps} onClick={() => onOpenModal()}>
        <span className={packageCardStyles.packageCardUsp}>
          <img src={TickGreenIcon} className={packageCardStyles.packageCardUspIcon} />
          <span className={packageCardStyles.packageCardUspText}>Lady Technician Available</span>
        </span>
        <span className={packageCardStyles.packageCardUsp}>
          <img src={TickGreenIcon} className={packageCardStyles.packageCardUspIcon} />
          <span className={packageCardStyles.packageCardUspText}>Parking Facility</span>
        </span>
        <span className={packageCardStyles.packageCardUsp}>
          <img src={TickGreenIcon} className={packageCardStyles.packageCardUspIcon} />
          <span className={packageCardStyles.packageCardUspText}>100% Covid Safe</span>
        </span>
      </div>

      {/* <div className={packageCardStyles.packageCardPriceDiv} onClick={() => handleBookClick(slug)}>
        <span className={packageCardStyles.packageCardOffer}>
          Offer Price:
        </span>
        <span className={packageCardStyles.packageCardOfferPrice}>
          ₹{offerPrice}
        </span>
        <span className={packageCardStyles.packageCardPrice}>
          ₹{price}
        </span>
      </div> */}

      <div className={packageCardStyles.packageCardBookAdd} onClick={() => onOpenModal()}>
        <span className={packageCardStyles.packageCardBook}>
          Book Now
        </span>{" "}
        {/* <div
          className={
            isAddedInCart
              ? `${packageCardStyles.packageCardCart} ${packageCardStyles.packageCardInCart}`
              : packageCardStyles.packageCardCart
          }
          onClick={handleAddToCartClick}
        >
          {
            isAddedInCart
              ? <CartIconFilled className={packageCardStyles.packageCardCartIcon} />
              : <CartIcon className={packageCardStyles.packageCardCartIcon} />
          }
        </div> */}
      </div>
    </div >
    
    </>
  )
}

export default PackageCard;